import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getAllWaiters = (token, restaurant) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "waiters/getall?restaurantid=" +
    restaurant +
    "&organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const filterWaitersTurnOver = (
  token,
  filteredWaiterIds,
  startDate,
  endDate,
  selectedRestaurant
) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "waiters/getturnover?organizationId=" +
    organizationId +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate;

  const bodyData = {
    waiterids: filteredWaiterIds,
    // startDate: startDate,
    // endDate: endDate,
    // restaurantId: selectedRestaurant,
  };

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(bodyData),
  };

  return fetchAndReturn(url, parameters);
};

export { getAllWaiters, filterWaitersTurnOver };
